/**
 * WARNING: This component is auto-generated by the build script in the parent directory.
 * Do not edit this file, as any changes will be overwritten. Instead, edit the template and
 * svg files to make changes
 */
import React from "react";
import classNames from "classnames";
import { IIconProps, IconSize } from "../types";

const Lead = (props: IIconProps): React.ReactElement => {
  const { className, size = IconSize.Medium, ...rest } = props;
  const iconClass = classNames("kl-icon", `kl-icon--${size}`, className);
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    <path
      fillRule="evenodd"
      d="M21.2 9.3H2.8c-.827 0-1.109 1.104-.382 1.5l4.948 2.7-1.797 7.516c-.188.784.772 1.32 1.342.75l5.11-5.11 5.07 5.07c.575.576 1.543.022 1.337-.766l-1.945-7.46 5.09-2.695c.737-.39.46-1.505-.373-1.505z"
      clipRule="evenodd"
    />,
    <circle cx={12} cy={5} r={3} opacity={0.6} />,
  );
};

export default Lead;
